import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaPayload } from '@utils/typescript';
import { otpUserFetch, passwordUpdate, stateUpdate, StateUpdatePayload } from './action';
import { OtpApi, AuthOtpTokenPasswordUpdateParams, AuthOtpTokenGetUserParams } from '@apis/OtpApi';
import { User } from '@models/User';
import { history } from '@utils/history';
import { SIGNIN_PATH } from '@config';

function* handlePasswordUpdate({ payload }: SagaPayload<AuthOtpTokenPasswordUpdateParams>) {
  const state: StateUpdatePayload = { errors: [] };
  try {
    yield call(OtpApi.updatePassword, payload);
    yield put(stateUpdate(state));
    history.navigate(SIGNIN_PATH, { replace: true });
  } catch (error) {
    state.errors?.push((error as Error).message);
    yield put(stateUpdate(state));
  }
}

function* handleOtpUserFetch({ payload }: SagaPayload<AuthOtpTokenGetUserParams>) {
  const state: StateUpdatePayload = { user: null };
  try {
    state.user = (yield call(OtpApi.get, payload)) as User;
    yield put(stateUpdate(state));
  } catch (error) {
    state.errors?.push((error as Error).message);
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(passwordUpdate, handlePasswordUpdate);
  yield takeLatest(otpUserFetch, handleOtpUserFetch);
}
